import { render, staticRenderFns } from "./historyCard.vue?vue&type=template&id=13694734"
import script from "./historyCard.vue?vue&type=script&lang=js"
export * from "./historyCard.vue?vue&type=script&lang=js"
import style0 from "./historyCard.vue?vue&type=style&index=0&id=13694734&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports